import React from "react";
import { Helmet } from 'react-helmet-async';
import Section from "./Section";
import { Container } from "reactstrap";
import JobApplication from "./JobApplication";

const ManageJobApplications = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Manage Job Application | Webvi </title>
      </Helmet>
      <Section />
      <section className="section">
        <Container>
          <JobApplication />
        </Container>
      </section>
    </React.Fragment>
  );
};

export default ManageJobApplications;
